import type { OnInit } from '@angular/core';
import { Component, Inject, Input } from '@angular/core';
import { Offer } from '@innogy/become-a-customer/shared/interfaces';
import { EnergyType } from '@essent/new-customer';
import {
  getMGMValue,
  getYearlyCostsLabel,
} from '@innogy/become-a-customer/shared';
import { ENVIRONMENT_CONFIG } from '@core/config-angular';
import type { EnvConfigBrand } from '@core/config-models';
import { EnvironmentConfig } from '@core/config-models';
import { ToolTipComponent } from '@legacy/common-ui-utility-components';
import { TextInterpolationPipe } from '@core/jss-utils';
import { CommonModule } from '@angular/common';

import { CommodityOfferLabels } from '../../../commodity-offers.model';
import { CommodityOfferEDProductBreakdownRowComponent } from '../commodity-product-breakdown-row/commodity-product-breakdown-row.component';

@Component({
  selector: 'ed-commodity-product-breakdown',
  templateUrl: './commodity-product-breakdown.component.html',
  styleUrls: ['./commodity-product-breakdown.component.ed.scss'],
  standalone: true,
  imports: [
    CommonModule,
    CommodityOfferEDProductBreakdownRowComponent,
    ToolTipComponent,
    TextInterpolationPipe,
  ],
})
export class CommodityOfferEDProductBreakdownComponent implements OnInit {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() offer?: Offer;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() content?: CommodityOfferLabels;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() showMemberGetMember = false;
  public energyType = EnergyType;

  brand?: EnvConfigBrand;

  constructor(
    @Inject(ENVIRONMENT_CONFIG) private readonly envConfig: EnvironmentConfig
  ) {}

  ngOnInit() {
    this.brand = this.envConfig.brand;
  }

  getMGMValue = (offer: Offer) =>
    this.brand ? getMGMValue(offer, this.brand).toString() : '';

  yearlyCostsLabel(offer: Offer) {
    return getYearlyCostsLabel(
      this.content?.yearlyCostsTotalDynamicWithIncentiveLabel ?? '',
      this.content?.yearlyCostsTotalDynamicWithoutIncentiveLabel ?? '',
      this.content?.yearlyCostsTotalWithIncentiveLabel ?? '',
      this.content?.yearlyCostsTotalWithoutIncentiveLabel ?? '',
      this.content?.yearlyCostsTotalMultiYearWithIncentiveLabel ?? '',
      this.content?.yearlyCostsTotalMultiYearWithoutIncentiveLabel ?? '',
      offer
    );
  }
}
